<div class="branding-content">
  <a class="branding-title"
     routerLink="/">
    AquaGuard
  </a>
</div>

<section class="mobile-nav-background"
         [class.active]="isNavigationOpen">
</section>
<ul class="mobile-navigation-list"
    [class.active]="isNavigationOpen">
  @for (navigation of navigationMenu; track $index) {
    @if (!navigation.needAccess || hasAccess(navigation.needAccess)) {
      <li class="list-item">
        <a [routerLink]="navigation.routerLink"
           [routerLinkActive]="'active'"
           [routerLinkActiveOptions]="{ exact: navigation.exact ?? true }"
           (click)="closNavigation()"
           class="button-link">
            <span class="material-symbols-rounded">
              {{ navigation.iconName }}
            </span>

          <p class="label">
            {{ navigation.isTranslated ? (navigation.tooltip | translateSafe) : navigation.tooltip }}
          </p>
        </a>
      </li>
    }
  }
</ul>

<div class="navigation-content">
  <ul class="navigation-list desktop-nav">
    @for (navigation of navigationMenu; track $index) {
      @if (!navigation.needAccess || hasAccess(navigation.needAccess)) {
        <li class="list-item">
          <app-button-icon iconName="{{navigation.iconName}}"
                           routerLink="{{navigation.routerLink}}"
                           routerLinkActive="active"
                           pTooltip="{{navigation.isTranslated ? (navigation.tooltip | translateSafe ) : navigation.tooltip}}"
                           tooltipPosition="bottom"
                           tooltipStyleClass="tooltip"
                           [routerLinkActiveOptions]="{ exact: navigation.exact ?? true }" />
        </li>
      }
    }
  </ul>

  <ul class="navigation-action-list">
    <li class="list-item"
        (click)="toggleTheme()">
      <app-button-icon iconName="{{theme === 'dark' ? 'light_mode' : 'dark_mode'}}"
                       pTooltip="{{ theme === 'dark' ? ('common.navigation.theme.light' | translateSafe) : ('common.navigation.theme.dark' | translateSafe) }}"
                       tooltipPosition="bottom"
                       tooltipStyleClass="tooltip" />
    </li>

    <li class="list-item"
        (click)="childMenu.toggle($event)">
      <app-button-icon iconName="account_circle"
                       [pTooltip]="'common.navigation.profile.title' | translateSafe"
                       tooltipPosition="bottom"
                       tooltipStyleClass="tooltip" />

      <p-popover #childMenu>
        <ul class="action-child-list"
            [class.active]="isChildMenuOpen">
          <li class="list-item"
              (click)="childMenu.toggle($event)">
            <app-button-icon iconName="person"
                             [isTranslated]="true"
                             label="common.actions.profile"
                             class="labeled"
                             (click)="openEditUserDialog();" />

          </li>

          <li class="list-item"
              (click)="doLogout(); childMenu.toggle($event)">
            <app-button-icon iconName="logout"
                             [isTranslated]="true"
                             label="common.actions.logout"
                             class="labeled" />
          </li>
        </ul>
      </p-popover>
    </li>
  </ul>

  <ul class="mobile-action">
    <li class="list-item"
        (click)="toggleNavigation()">
      <app-button-icon iconName="menu"
                       pTooltip="Menü"
                       tooltipPosition="bottom"
                       tooltipStyleClass="tooltip" />
    </li>
  </ul>
</div>
<app-dialog-base
  [class.open]="isEditDialogOpen"
  (click)="openEditUserDialog()"
  iconLeft="edit"
  [buttonAction]="closeEditUserDialog"
  [title]="currentAccount?.username ? ('dialogs.profile.edit-user' | translate:
  {'username': currentAccount!.username}) : ''">

  <app-dialog-edit-user
    [account]="currentAccount"
    [isCurrentAccount]="true"
    (updated)="closeEditUserDialog()" />

</app-dialog-base>
